import styled from 'styled-components';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 30px;
	margin: 15px 0;
`;

export const Text = styled.div`
	color: #29185e;
	text-align: center;
	font-family: 'Work Sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 600;
	line-height: 120%; /* 19.2px */
`;

export const HandsContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-around;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  margin-bottom: 20px;
`;

export const HandButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #edeffe;
	border-radius: 50%;
  width: 80px;
  aspect-ratio: 1;
`;

export const HandIcon = styled.img`
	width: 40px;
`;
